import Vue from 'vue'

export var bus = new Vue({
    methods: {
        login(response) {
            this.$emit('login', response)
        },
        errorlogin(response) {
            this.$emit('errorlogin', response)
        },
        responseressetpass(response) {
            this.$emit('responseressetpass', response)
        }
    }
})